<template>
  <v-switch
    class="tema-eixo-combo"
    id="temas-select"
    v-model="editValue[value]"
    v-on:change="$emit('onChange')"
    :disabled="disabled"
  >
  </v-switch>
</template>

<script>
export default {
  name: "AppYesOrNOCombobox",
  props: {
    editValue: { type: Object, default: 0 },
    disabled: { type: Boolean, default: false },
    value: { type: String, default: "habilitado" },
  },
  data() {
    return {
      yesOrNo: [
        {
          label: "Sim",
          value: true,
        },
        {
          label: "Não",
          value: false,
        },
      ],
    };
  },
};
</script>

<style scoped>
.tema-eixo-combo {
  padding: 0 24px 20px;
}
</style>
